module.exports = __webpack_public_path__ + "img/PL.e3fd1fc4.webp";